import { graphql } from "@/graphql"

export function getReactionSummary(
  reactions: ReadonlyArray<{ emoji: string; count: number }>,
): ReactionSummary {
  const sorted = [...reactions].sort((a, b) => b.count - a.count)

  return {
    topEmojis: sorted.slice(0, 3).map(reaction => reaction.emoji),
    totalCount: reactions.reduce((sum, reaction) => sum + reaction.count, 0),
  }
}

export const PostReactionSummaryFragment = graphql(`
  fragment PostReactionSummary on Post {
    reactions {
      emoji
      count
    }
  }
`)

export const PublishedPostReactionSummaryFragment = graphql(`
  fragment PublishedPostReactionSummary on PublishedPost {
    reactions {
      emoji
      count
    }
  }
`)

interface ReactionSummary {
  topEmojis: string[]
  totalCount: number
}
